export class SolveIssuesResponse {
  constructor(
    public readonly pendingPostsBefore: number,
    public readonly pendingPostsAfter: number,
  ) {}
}
